import React from 'react';
import Icon from '../../icon/index';
import { SearchResultContext } from '../context/SearchResultContext';
import Select from '../../select/Select';
import { trackSearchEvent } from '../api/request';
import NoResults from './NoResults';

const Blog = (props) => {

    const { results, sortOrder, setSortOrder, language, endpoint } = React.useContext(SearchResultContext);

    if (results.items.length <= 0) return <NoResults heading={props.noResultsHeading} preamble={props.noResultsPreamble} query={props.query} />;

    return (
        <div className='search-result-block'>
            <div className='h-display-flex h-justify-content-end'>
                <Select label={`${props.sortByLabel}`} options={props.sortOptions.map(i => ({ value: i.sortOrder, label: i.displayName }))} value={sortOrder} onChange={(e) => {
                    setSortOrder(e.target.value);
                }} />
            </div>
            <div className="row row--justify-around">
                <div className="search-result-content">
                    {results.items.map((item) => {
                        return (
                            <div className="search-content__body">
                                <a href={item.url} target='_blank' onClick={() => trackSearchEvent(language, endpoint, results.query, item.hitId)}>
                                    <div className="row--justify-between search-content__category">
                                        <h3 className="headline-4 h-padding-right-8">{item.title ? item.title : ''}</h3>
                                        <span class="search-content-link">
                                            <Icon icon="external-link" />
                                        </span>
                                    </div>
                                    <p className="search-content-hit-type-name">{item.searchHitObject && item.searchHitObject.contentType ? item.searchHitObject.contentType : ''}</p>
                                    <p className="search-content-description h-truncate-3">{item.description ? item.description : ''}</p>
                                </a>
                            </div>
                        );
                    }
                    )}
                </div>
            </div>
        </div>
    );
};

export default Blog;
